import React, { FC, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { Box, Button, Flex, Heading } from '@chakra-ui/react';

import { UserPill } from 'components/core/UserPill';
import { PackagesList } from 'components/modules/PackagesList';
import { PendingCounts } from 'components/modules/PendingCounts';
import { OrderRequests } from 'components/modules/OrderRequests';
import { EventsCalendar } from 'components/modules/EventsCalendar';

import { DashboardViewProps } from './Dashboard.props';
import { MdAddLocationAlt, MdMoreTime } from 'react-icons/md';
import {
  AddPickupModal,
  AddPickupModalRef,
} from 'components/modules/AddPickupModal';
import { HiDocumentAdd } from 'react-icons/hi';
import {
  AddOrderModal,
  AddOrderModalRef,
} from 'components/modules/AddOrderModal';
import { ReadyForReport } from 'components/modules/ReadyForReport';
import { ReportInReview } from 'components/modules/ReportInReview';
import AddInventoryCountModal, {
  RefType,
} from 'components/modules/AddInventoryCountModal';

import { routesSettings } from 'constants/routes';
import { washHub } from 'store/slices';

const DashboardView: FC<DashboardViewProps> = () => {
  const navigate = useNavigate();
  const addPickupModalRef = useRef<AddPickupModalRef>(null);
  const addOrderModalRef = useRef<AddOrderModalRef>(null);
  const [selectedDay, setSelectedDay] = useState(new Date());
  const addInventoryCountModalRef = useRef<RefType>(null);

  const selectedWashHubId = washHub.selectors.useSelectedWashHubId();

  return (
    <Flex
      gap="20px"
      direction="column"
      flex={1}
      color="#262626"
      css={{ scrollbarGutter: 'stable' }}>
      <Flex alignItems="baseline" justify="space-between">
        <Heading fontSize="24px">Dashboard</Heading>
        <Flex align="flex-end">
          <Button
            mr={2}
            minW="200px"
            leftIcon={<MdMoreTime size="20px" />}
            onClick={() => {
              addInventoryCountModalRef.current?.onOpen?.();
            }}>
            Schedule Count
          </Button>
          <Button
            isDisabled={selectedWashHubId === ''}
            mr={2}
            minW="200px"
            leftIcon={<MdAddLocationAlt size="20px" />}
            onClick={() => {
              addPickupModalRef?.current?.onOpen?.();
            }}>
            Add Pickup
          </Button>
          <Button
            isDisabled={selectedWashHubId === ''}
            mr={2}
            minW="200px"
            leftIcon={<HiDocumentAdd size="20px" />}
            onClick={() => {
              addOrderModalRef.current?.onOpen?.();
            }}>
            Create Order
          </Button>
          <UserPill />
        </Flex>
      </Flex>

      <EventsCalendar
        setSelectedDay={setSelectedDay}
        selectedDay={selectedDay}
      />
      <Button
        mt="10px"
        minW="200px"
        maxW="500px"
        onClick={() => {
          navigate(routesSettings.PORTAL_ORDERS_SUMMARY.getPath());
        }}>
        View Orders Summary
      </Button>
      <Flex mt="10px" gap="20px" flexWrap="wrap">
        <OrderRequests />
        <PackagesList />
        <PendingCounts />
        <Box minW="400px">
          <ReadyForReport />
        </Box>
        <Box minW="400px">
          {' '}
          <ReportInReview />
        </Box>
      </Flex>
      <AddPickupModal ref={addPickupModalRef} selectedDay={selectedDay} />
      <AddOrderModal ref={addOrderModalRef} selectedDay={selectedDay} />
      <AddInventoryCountModal ref={addInventoryCountModalRef} />
    </Flex>
  );
};

export default DashboardView;
